import React from "react";
import AdminDashboard from "../views/mains/AdminMain";
import AddCargo from "../views/cargo/add-cargo/AddCargo";
import EditCargo from "../views/cargo/edit/EditCargo"; 
import Cargos from "../views/cargo/cargos/Cargos";
//import CargosUsers from "../views/manage-users-cargos/cargos/Cargos"; 
//import DriverReserves from "../views/info-complemental/reserve-list/Reserve"; 
import CargosUsers from "../views/cargo/cargos/Cargos"; 
import DriverReserves from "../views/info-complemental/reserve-list/Reserve"; 

import DriverReservesUsers from "../views/info-complemental/reserve-list/Reserve";
import Customer from "../views/info-base/customer/Customer"; 
import Estelam from "../views/estelam/estelam-base/Estelam";
 
import AddUser from "../views/manage-users/add-user/AddUser";
import ManageUser from "../views/manage-users/manage-users/ManageUser"; 
import Notifications from "../views/notifications/notifications/Notifications"; 
import LoadHallCargo from "../views/app/loadhall-setting-pages/LoadHallCargo";
import LoadHallReserve from "../views/app/loadhall-setting-pages/LoadHallReserve";
 
 
 
 
  
import ManageTransportationCompany from "../views/manage-transportationcompanys/manage-transportationcompany/ManageTransportationCompany";
import MainBranchIndex from "../views/manage-transportationcompanys/manage-main-branch/MainBranchIndex"; 
import DriverSearch from "../views/manage-drivers/DriverSearch/DriverSearch";
import InActive from "../views/manage-drivers/inactive-drivers/InActive";
import AddDriver from "../views/manage-drivers/add-driver/AddDriver"; 
import AdminCargos from "../views/cargo/cargos/Cargos";
import AdminDriverReserve from "../views/info-complemental/reserve-list/Reserve"; 
import Contact from "../views/app/admin-pages/change-contact-info/Contact";
 
import AdminUser from "../views/manage-users/admin-manage-users/AdminUser";
 
 
import OnlineCharge from "../views/SalePayment/OnlineCharge";
import Comment from "../views/Comment/ManageComment";
import AdminComment from "../views/Comment/AdminManageComment";
//import ReturnBank from "../views/SalePayment/ReturnBank";
import ManageProductOwner from "../views/app/admin-pages/manage-product-owner/ManageProductOwner";
import ManageProfile from "../views/app/admin-pages/manage-profile/Profile";

export default [
    {
        path: '',
        component: AdminDashboard,
        roles: [
            "Admin"
        ],
        access_code: null
    },
    {
        path: 'OnlineCharge',
        component: OnlineCharge,
        roles: [
            "TransportationCompanyAdmin"
        ],
        
    },
     
    {
        path: 'AddCargo',
        component: AddCargo,
        roles: [
            "TransportationCompanyAdmin",
            "ProductOwnerAdmin"
        ],
        access_code: "access_Cargo_Add"
    },
    
    {
        path: 'EditCargo/:cargoId',
        component: EditCargo,
        roles: [
            "TransportationCompanyAdmin",
            "ProductOwnerAdmin",
        ]
    },
    {
        path: 'AddUser',
        component: AddUser,
        roles: [
            "TransportationCompanyAdmin"
        ],
        access_code: null
    },
     
    {
        path: 'TransportationCompany',
        component: ManageTransportationCompany,
        roles: [
            "Admin"
        ],
        access_code: null
    },
    {
        path: 'Profile',
        component: ManageProfile,
        roles: [
            "TransportationCompanyAdmin",
            "ProductOwnerAdmin",
            "Driver",
        ],
        access_code: null
    },
    {
        path: 'Admin/Driver/InActive',
        component: InActive,
        roles: [
            "Admin",
            "AdminSupport"
        ],
        access_code: null
    },
    {
        path: 'Driver/AddDriver',
        component: AddDriver,
        roles: [
            "Admin",
            "AdminSupport"
        ],
        access_code: null
    },
     
    {
        path: 'Driver/Drivers',
        component: DriverSearch,
        roles: [
            "Admin",
            "AdminSupport"
        ],
        access_code: null
    },
     
    {
        path: 'AdminCargos',
        component: AdminCargos,
        roles: [
            "Admin",
            "AdminSupport"
        ],
        access_code: null
    },
    {
        path: 'AdminDriverReserve',
        component: AdminDriverReserve,
        roles: [
            "Admin",
            "AdminSupport"
        ],
        access_code: null
    },
      
     
      
    
    {
        path: 'Admin/Settings/Contact',
        component: Contact,
        roles: [
            "Admin"
        ],
        access_code: null
    },
     
     
   
   
    {
        path: 'AdminUser',
        component: AdminUser,
        roles: [
            "Admin"
        ],
        access_code: null
    },
       
    
    {
        path: 'Customer',
        component: Customer,
        roles: [
            "TransportationCompanyAdmin"
        ],
        access_code: "access_Customer_List"
    }, 
     
    
    
     
     
    {
        path: 'Estelam',
        component: Estelam,
        roles: [
            "Customer",
            "AgentMain",
            "TransportationCompanyAdmin",
            "CustomerAdvancedMember"
        ],
        access_code: null
    },
      
     
    {
        path: 'Cargos',
        component: Cargos,
        roles: [
            "TransportationCompanyAdmin",
            "Driver",
            "ProductOwnerAdmin",
        ],
        access_code: "access_Load_Manage"
    },
     
    {
        path: 'CargosUsers',
        component: CargosUsers,
        roles: [
            "Organization",
            "DriversAssociation",
            "AssociationTransportCompanies",
        ],
        access_code: "access_Load_Manage"
    },
     
    

    
     
    
    {
        path: 'MainBranchIndex',
        component: MainBranchIndex,
        roles: [
            "Admin"
        ],
        access_code: null
    },
     
    {
        path: 'ManageUser',
        component: ManageUser,
        roles: [
            "TransportationCompanyAdmin"
        ],
        access_code: null
    },
     
     
    {
        path: 'Notifications',
        component: Notifications,
        roles: "all"
    },
     
     
    {
        path: 'DriverReserves',
        component: DriverReserves,
        roles: [
            "TransportationCompanyAdmin",
            "Driver",
            "ProductOwnerAdmin",
        ],
        access_code: "access_Reserve_List"
    },
    {
        path: 'DriverReservesUsers',
        component: DriverReservesUsers,
        roles: [
            "Organization",
            "DriversAssociation",
            "AssociationTransportCompanies",
        ],
        access_code: "access_Reserve_List"
    },
      
    {
        path: 'LoadHallCargo',
        component: LoadHallCargo,
        roles: [
            "LoadHallAdmin"
        ],
        access_code: null
    },
    {
        path: 'LoadHallReserve',
        component: LoadHallReserve,
        roles: [
            "LoadHallAdmin"
        ],
        access_code: null
    },
    {
        path: 'Comment',
        component: Comment,
        roles: [
            "TransportationCompanyAdmin",
            "Driver",
            "ProductOwnerAdmin",
        ],
        access_code: "access_Cargo_Add"
    },
    {
        path: 'AdminComment',
        component: AdminComment,
        roles: [
            "Admin"
        ],
        access_code: "access_Cargo_Add"
    },
    {
        path: 'ManageProductOwner',
        component: ManageProductOwner,
        roles: [
            "Admin"
        ],
        access_code: null
    },
   
]

